import React from 'react';

import {
  AppBar,
  Tab,
  Tabs,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import Absence from './Absence';
import History from './History';
import Late from './Late';
import LeaveEarly from './LeaveEarly';
import {
  attendContactAbsencesSelector,
  attendContactLatesSelector,
  attendContactLeaveEarlysSelector,
  isInitAbsenceSelector,
  isInitLateSelector,
  isInitLeaveEarlySelector,
} from './selector';
import {
  refreshAttendContactAbsenceList,
  refreshAttendContactLateList,
  refreshAttendContactLeaveEarlyList,
} from './thunk';

import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';

import Title from '@/components/Title';

/**
 * プロパティ
 */
export type Props = {
  /** 子ども */
  child: ChildJson,
  /** 子どもの施設リスト */
  facilityList: FacilityJson[],
};

const AttendContact: React.FC<Props> = ({ child, facilityList }) => {
  const [indexType, setIndexType] = React.useState(0);
  React.useEffect(() => {
    const handler = () => setIndexType(0);
    window.addEventListener('wagako:goAttendHistory', handler);
    return () => window.removeEventListener('wagako:goAttendHistory', handler);
  }, []);
  const dispatch = useDispatch();
  const absenceList = useSelector(attendContactAbsencesSelector);
  const lateList = useSelector(attendContactLatesSelector);
  const leaveEarlyList = useSelector(attendContactLeaveEarlysSelector);
  const isInitAbsence = useSelector(isInitAbsenceSelector);
  const isInitLate = useSelector(isInitLateSelector);
  const isInitLeaveEarly = useSelector(isInitLeaveEarlySelector);
  React.useEffect(() => {
    if (!isInitAbsence) {
      dispatch(refreshAttendContactAbsenceList());
    }
    if (!isInitLate) {
      dispatch(refreshAttendContactLateList());
    }
    if (!isInitLeaveEarly) {
      dispatch(refreshAttendContactLeaveEarlyList());
    }
  }, [dispatch, isInitAbsence, isInitLate, isInitLeaveEarly]);
  // 登録
  if (facilityList.length === 0) {
    return (
      <div>
        <Title title="登降園連絡" />
        <p>施設登録がありません</p>
      </div>
    );
  }
  let content = null;
  if (indexType === 0) {
    content = (
      <History
        absenceList={absenceList}
        lateList={lateList}
        leaveEarlyList={leaveEarlyList}
        child={child}
      />
    );
  } else if (indexType === 1) {
    content = <Absence child={child} facilityList={facilityList} />;
  } else if (indexType === 2) {
    content = <Late child={child} facilityList={facilityList} />;
  } else {
    content = <LeaveEarly child={child} facilityList={facilityList} />;
  }
  return (
    <div>
      <Title title="登降園連絡" />
      <div>
        <AppBar position="static" color="default">
          <Tabs
            value={indexType}
            onChange={(_, newIndex) => {
              if (typeof newIndex === 'number') {
                setIndexType(newIndex);
              }
            }}
            indicatorColor="secondary"
            textColor="inherit"
            variant="fullWidth"
          >
            <Tab
              label="履歴"
              id="history"
            />
            <Tab
              label="欠席"
              id="absence"
            />
            <Tab
              label="遅刻"
              id="late"
            />
            <Tab
              label="早退"
              id="leavingEarly"
            />
          </Tabs>
        </AppBar>
        {content}
      </div>
    </div>
  );
};

export default AttendContact;
